import { axiosPrivate } from 'shared/api';
import { BaseService } from './BaseService';

/**
 * Service providing export capabilities for resource entities.
 * Extends {@link BaseService} by adding automated file download handling for exported resources.
 *
 * @template T - The entity type, constrained to objects containing a numeric `id`.
 */
export class ExportableResourceService<T extends { id: number }> extends BaseService<T> {
  /**
   * Fetches an export file as a binary blob from the endpoint and triggers
   * an automatic browser download using the filename specified in the response headers.
   *
   * @param _ - Optional query or filter parameters for the export request.
   * @returns A promise that resolves once the download request has been dispatched.
   */
  exportAll = async (_?: Record<string, unknown>) => {
    axiosPrivate
      .get(`${this.modulePrefix}/export/`, {
        responseType: 'blob'
      })
      .then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const contentDisposition = res.headers['content-disposition'];
        if (contentDisposition?.indexOf('attachment') !== -1) {
          const filenameMatches = contentDisposition.match(
            /(?:.*filename\*|filename)=(?:([^'"]*)''|("))([^;]+)\2(?:[;`\n]|$)/
          );
          const filename = filenameMatches.pop();
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
        }
      });
  };
}
